import { HfsSettingsActionEnum } from 'fleet-data-model';
import { type Update } from '../../types';

export const mapEcoModeExecutionTargets = (update: Update) => [
  {
    hfsActionId: HfsSettingsActionEnum.ECO_MODE_ENABLED,
    iprId: update.assetId,
    payload: {
      enabled: update.enabled,
    },
  },
];
